'use strict'

function resolveAll(constructs, events, context) {
  var called = []
  var index = -1
  var resolve

  while (++index < constructs.length) {
    resolve = constructs[index].resolveAll

    if (resolve && called.indexOf(resolve) < 0) {
      events = resolve(events, context)
      called.push(resolve)
    }
  }

  return events
}

module.exports = resolveAll



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/util/resolve-all.js
// module id = 437
// module chunks = 0